module.exports = __webpack_public_path__ + "img/collections_select.88f7be14.png";